export const DEFAULT_PAGE = 1;
export const OPTIONS_ITEMS_PER_PAGE = [12, 24, 36, 48];
export const ITEMS_PER_PAGE = OPTIONS_ITEMS_PER_PAGE[0];
